import { rutinInfos } from '../../_Common/Const/RutinInfo';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../../_Common/Components/ListRutin/ListRutin';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const TIRutiner = {
  rtnAnstalld: {
    component: getStandardRutin(rutinInfos.rtnAnstalld, 'TIAnstalld'),
  },
  rtnRapporteringsobjekt: {
    component: getStandardRutin(
      rutinInfos.rtnRapporteringsobjekt,
      'TIAnstalld'
    ), // Samma som Anstallda
  },
  rtnTIProjekt: {
    component: getStandardRutin(rutinInfos.rtnTIProjekt, 'TIProjekt'),
  },
  rtnArbetsuppgifter: {
    component: getStandardRutin(
      rutinInfos.rtnArbetsuppgifter,
      'TIArbetsuppgift'
    ),
  },
  rtnAnstalldBegr: {
    component: getStandardRutin(rutinInfos.rtnAnstalldBegr, 'TIAnstalld'), // Samma som Anstallda
  },
  rtnTidrapporteringBegr: {
    component: getStandardRutin(
      rutinInfos.rtnTidrapporteringBegr,
      'TIDagAnstalld'
    ), // Sammma som Tidregistrering
  },
  rtnPeriodregistreringBegr: {
    component: getStandardRutin(
      rutinInfos.rtnPeriodregistreringBegr,
      'TIManAnstalld'
    ), // Samma som Periodregistrering
  },
  rtnFordelaTidBegr: {
    component: getStandardRutin(rutinInfos.rtnFordelaTidBegr, 'TIManAnstalld'), // Samma som MinPeriodregistrering
  },
  rtnRegistreraForDemo: {
    component: withAddStartedRoutine(rutinInfos.rtnRegistreraForDemo)(
      createListRutin(
        'TIAnstalld',
        [{ attributeDef: 'namnNr', caption: '' }],
        notImplemented('Registrera för demo DetailComp')
      )
    ),
  },
  rtnTidregistrering: {
    component: getStandardRutin(rutinInfos.rtnTidregistrering, 'TIDagAnstalld'),
  },
  rtnPeriodregistrering: {
    component: getStandardRutin(
      rutinInfos.rtnPeriodregistrering,
      'TIManAnstalld'
    ),
  },
  rtnFordelaTid: {
    component: getStandardRutin(rutinInfos.rtnFordelaTid, 'TIManAnstalld'), // Samma som Periodregistrering
  },
  rtnTidrapporteringar: {
    component: getStandardRutin(
      rutinInfos.rtnTidrapporteringar,
      'TITidrapportering'
    ),
  },
  rtnDagrapporteringar: {
    component: withAddStartedRoutine(rutinInfos.rtnDagrapporteringar)(
      createListRutin(
        'TIDagAnstalld',
        [
          { attributeDef: 'anstalld.ANSTALLNINGSNR', caption: 'Nr' },
          {
            attributeDef: 'anstalld.namn',
            caption: 'Namn/Benämning från Anställd',
          },
          { attributeDef: 'datum', caption: 'Datum' },
          { attributeDef: 'veckodag', caption: 'Dag' },
          { attributeDef: 'rapporteratFran', caption: 'Fråntid' },
          { attributeDef: 'rapporteratTill', caption: 'Tilltid' },
          { attributeDef: 'arbetstid', caption: 'Tid' },
          { attributeDef: 'flextid', caption: '+/-' },
          { attributeDef: 'schemaOchDagschema', caption: 'Schema' },
          { attributeDef: 'dagArbetstid', caption: 'Mått' },
        ],
        notImplemented('Dagrapporteringar DetailComp')
      )
    ),
  },
  rtnManadsAvslut: {
    component: withAddStartedRoutine(rutinInfos.rtnManadsAvslut)(
      createListRutin(
        'TIManAnstalld',
        [
          { attributeDef: 'anstalldNrNamn', caption: 'Anställd' },
          { attributeDef: 'MANAD', caption: 'Månad' },
          { attributeDef: 'status', caption: 'Status' },
          { attributeDef: 'verStatus', caption: 'Bokföring' },
        ],
        notImplemented('Manadsavslut DetailComp')
      )
    ),
  },
  rtnLoneunderlag: {
    component: getStandardRutin(rutinInfos.rtnLoneunderlag, 'TILonefil'),
  },
  rtnSpecTIRapport: {
    component: getStandardRutin(rutinInfos.rtnSpecTIRapport, 'Tidrapport'),
  },

  rtnPafyllSemDagar: {
    component: withAddStartedRoutine(rutinInfos.rtnPafyllSemDagar)(
      createListRutin(
        'TIAnstalld',
        [
          { attributeDef: 'ANSTALLNINGSNR', caption: 'Nr' },
          { attributeDef: 'namn', caption: 'Namn/Benämning' },
          { attributeDef: 'SEMESTERFAKTOR', caption: 'Semesterfaktor' },
          { attributeDef: 'AntalSemratt', caption: 'Semesterrätt' },
          { attributeDef: 'AntalSemdagar', caption: 'Aktuellt semestersaldo' },
          { attributeDef: 'FattSemForAr', caption: 'Uppräknat t.o.m' },
        ],
        notImplemented('PafyllningSemesterdagar DetailComp')
      )
    ),
  },
  rtnOBRegistrering: {
    component: withAddStartedRoutine(rutinInfos.rtnOBRegistrering)(
      createListRutin(
        'TITidrapportering',
        [
          { attributeDef: 'namn', caption: 'Namn' },
          { attributeDef: 'DATUM', caption: 'Datum' },
          { attributeDef: 'JobbatFrom', caption: 'Arbtid från' },
          { attributeDef: 'JobbatTom', caption: 'Arbtid till' },
          { attributeDef: 'OB_A', caption: 'OB, A' },
          { attributeDef: 'OB_B', caption: 'OB, B' },
          { attributeDef: 'OB_C', caption: 'OB, C' },
          { attributeDef: 'OB_D', caption: 'OB, D' },
          { attributeDef: 'OBFrom', caption: 'Fråntid' },
          { attributeDef: 'OBTom', caption: 'Tilltid' },
          { attributeDef: 'RAPP_TIRAPKOD_BEN', caption: 'Rapporteringskod' },
          { attributeDef: 'OBFinnsILonefil', caption: 'Finns i lönefil' },
        ],
        notImplemented('OBRegistrering DetailComp')
      )
    ),
  },
};

export default TIRutiner;
